import React, { } from "react";
import Container from "../../General/Container/Container";
import { Skeleton } from "antd";

const PersonasInfoItem = ({ label, value }) => {
    return <Container className="drow gap-5p">
        <span className="personas-info-label">{label}: </span>
        <span className="">{value}</span>
    </Container>
}
const PersonasInfoGroup = ({
    title = "Title",
    list = null,
    children,
    classColor = "green",
    loading,
    className = "",
    style = {}
}) => {
    return <Container className={`dcol gap-5p${loading ? " flex-1" : ""} ${className}`} style={style}>
        {loading
            ? <Skeleton paragraph={{ rows: 5 }} active />
            : <>
                <span className={`personas-title${classColor}`}>{title}</span>
                {list ? list.map((item) => {
                    return <PersonasInfoItem label={item.label} value={item.value} />
                }) : list}
                {children}
            </>
        }

    </Container>
}

export default PersonasInfoGroup